module.exports = __webpack_public_path__ + "static/media/new-mysql.58b4068d.svg";